<div class="table-container table-responsive">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{column.header}}
      </th>
      <td mat-cell *matCellDef="let row" [innerHTML]="column.cell(row) | sanitizeHtml"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
<div class="pagination-container">
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="getAll($event)"
    [pageIndex]="pageIndex">
  </mat-paginator>
</div>